import Clamp from 'clamp-js';

export default {
    addClamp(element) {
        Clamp($(element)[0], {clamp: $(element).data('clamp')});
    },
    init() {
        $('[data-clamp]').each((index, element) => {
            this.addClamp(element);
        });
    }
};